import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.css']
})
export class ConfirmDeleteComponent implements OnInit {

  constructor() { }
  d(any) {
    console.log(any);
  }
  c(any) {
    console.log(any);
  }
  ngOnInit() {
  }

}
